/**
 * Reidratação dos Autocomplete a partir dos ids que vieram da URL.
 *
 * As opções (useApp / useSWR) carregam depois do primeiro render, então o
 * filtro precisa casar id -> objeto assim que a lista chega.
 */

export const matchOptions = (options, selected) => {
  if (!options?.length || !selected?.length) return [];
  return selected.map((item) => options.find((o) => String(o?.id) === String(item?.id ?? item))).filter(Boolean);
};

export const matchOption = (options, id) => {
  if (!options?.length || id === undefined || id === null || id === '') return null;
  return options.find((o) => String(o?.id) === String(id)) || null;
};
